<ng-container [formGroup]="nameFormGroup">
  <div class="row">
    <div class="demo-overlay" *ngIf="isDemo"></div>
    <div class="col-md-4">
      <div class="form-group">
        <div class="select-wrapper">
          <label for="title" class="visually-hidden">Title</label>
          <select id="title" class="form-control" formControlName="Title" [ngClass]="{'disabled': isDemo}">
            <option [ngValue]="null" label="Select Title" selected="selected"></option>
            <option *ngFor="let opt of Prefix" [value]="opt.key">
              {{ opt.value }}
            </option>
          </select>
        </div>
        <error-messages [form]="parent" [field]="formGroupParent + '.Title'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <div class="col-md-8">
      <div class="form-group">
        <label for="firstName" class="visually-hidden">First Name</label>
        <input id="firstName" type="text" class="form-control" formControlName="FirstName" maxlength="19" placeholder="First" [ngClass]="{'input-required': isRequired && !isDemo, 'disabled': isDemo}">
        <error-messages [form]="parent" [field]="formGroupParent + '.FirstName'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="middleName" class="visually-hidden">Middle Name</label>
        <input id="middleName" type="text" class="form-control" formControlName="MiddleName" maxlength="20" placeholder="Middle" [ngClass]="{'disabled': isDemo}">
        <error-messages [form]="parent" [field]="formGroupParent + '.MiddleName'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <div class="col-md-8">
      <div class="form-group">
        <label for="lastName" class="visually-hidden">Last Name</label>
        <input id="lastName" type="text" class="form-control" formControlName="LastName" maxlength="20" placeholder="Last" [ngClass]="{'input-required': isRequired && !isDemo, 'disabled': isDemo}">
        <error-messages [form]="parent" [field]="formGroupParent + '.LastName'" skipFeedback="true"></error-messages>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <div class="select-wrapper">
          <label for="suffix" class="visually-hidden">Suffix</label>
          <select id="suffix" class="form-control" formControlName="Suffix" [ngClass]="{'disabled': isDemo}">
            <option [ngValue]="null" label="Select Suffix" selected="selected"></option>
            <option *ngFor="let opt of Suffix" [value]="opt.key">
              {{ opt.value }}
            </option>
          </select>
        </div>
        <error-messages [form]="parent" [field]="formGroupParent + '.Suffix'" skipFeedback="true"></error-messages>
      </div>
    </div>
  </div>
</ng-container>